// removed by extract-text-webpack-plugin
module.exports = {"container":"container___2r7uY","wrapper":"wrapper___b9q15","logo":"logo___3nhnA","info":"info___5Qjbl","modal":"modal___Yyjnq","header":"header___18Irq","body":"body___2UFTk","close":"close___3O5dT","overlay":"overlay___2W1FM","hidden":"hidden___1i2AU","form":"form___2Bxla","gapBottom45":"gapBottom45___1M9Jv","gapTop20":"gapTop20___2w0A5","content":"content___3eWw_","package":"package___3xyxJ","unit":"unit___3PZAQ","label":"label___3n_Yl","intro":"intro___xTjnT","pinfo":"pinfo___Vav3d"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Page2.scss
// module id = 49
// module chunks = 0